
import React from 'react';
import EditorialLayout from '@/components/editorial/EditorialLayout';
import { PublishHistoryHeader } from '@/components/publish/PublishHistoryHeader';
import { PublishHistoryContent } from '@/components/publish/PublishHistoryContent';

const PublishHistoryPage: React.FC = () => {
  return (
    <EditorialLayout>
      <div className="container mx-auto px-4 py-8">
        <PublishHistoryHeader />
        <PublishHistoryContent />
      </div>
    </EditorialLayout>
  );
};

export default PublishHistoryPage;
